<template>
  <div class="landingSection4">
    <landing-container>
      <h3 class="landingSection4__title">
        {{ $t('Download now') }}
      </h3>
      <div class="landingSection4__dividerWrapper">
        <divider />
      </div>

      <div class="landingSection4__wrap">
        <div class="landingSection4__wallet wallet">
          <img
            class="wallet__logo"
            src="~img/landing/plc_wallet.svg"
            alt="Wallet"
          />
          <p class="wallet__title">
            Ultima <span class="textW--primary">Wallet</span>
          </p>
        </div>

        <ul class="landingSection4__benefits benefitsList">
          <li class="benefitsList__item">
            <img src="~img/landing/ic_easy.svg" alt="Easy" />
            <div>
              <h6 class="benefitsList__title">
                {{ $t('Easy') }}
              </h6>
              <p class="benefitsList__text">
                {{ $t('Easy and simple, with full control of your PLCU') }}
              </p>
            </div>
          </li>
          <li class="benefitsList__item">
            <img src="~img/landing/ic_protection.svg" alt="Protection" />
            <div>
              <h6 class="benefitsList__title">
                {{ $t('Safe') }}
              </h6>
              <p class="benefitsList__text">
                {{ $t('The Private Key is only stored on your smartphone.') }}
              </p>
            </div>
          </li>
          <li class="benefitsList__item">
            <img src="~img/landing/ic_transactions.svg" alt="Transactions" />
            <div>
              <h6 class="benefitsList__title">
                {{ $t('Functional') }}
              </h6>
              <p class="benefitsList__text">
                {{
                  $t(
                    'Receive, send, store PLCU. Can be integrated in the application and the ULTIMA Farm and stores all minted coins.'
                  )
                }}
              </p>
            </div>
          </li>
        </ul>

        <div class="landingSection4__preview appPreview">
          <img
            src="~img/landing/phones.png"
            srcset="~img/landing/phones@2x.png 2x"
            alt="Phones"
          />
        </div>

        <div class="landingSection4__stores stores">
          <h6 class="stores__title">
            {{ $t('Unprecedented level of security to date') }}
          </h6>
          <div class="stores__wrap">
            <a :href="appWalletApple" target="_blank" rel="noreferrer"
              ><img src="~img/landing/appstore.png" alt="App Store"
            /></a>
            <a :href="appWalletGoogle" target="_blank" rel="noreferrer"
              ><img
                src="~img/landing/googleplay.png"
                title="Google Play"
                alt="Google Play"
            /></a>
          </div>
        </div>
      </div>

      <div class="landingSection4__btnWrapper">
        <a
          :href="toRegistration"
          class="landingSection4__btn btnFarm btnFarm--primary btnFarm--lg"
        >
          {{ $t('Sign up') }}
        </a>
      </div>
    </landing-container>
  </div>
</template>

<script>
import LandingContainer from '@/components/Landing/components/LandingContainer.vue'
import Divider from '@/components/Landing/components/Divider'

import { appWalletGoogle, appWalletApple } from '@/config'
import { toRegistration } from '@/tools'

export default {
  components: { Divider, LandingContainer },
  name: 'LandingSection4',
  data() {
    return {
      appWalletGoogle,
      appWalletApple,
    }
  },
  computed: {
    toRegistration,
  },
}
</script>

<style lang="scss" scoped>
.landingSection4 {
  padding: 48px 0;

  @media (min-width: $breakpoint-md) {
    padding: 64px 0;
  }

  @media (min-width: $breakpoint-xl) {
    padding: 96px 0;
  }

  &__title {
    color: #1c1c1e;
    font-family: $font-secondary;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;

    @media (min-width: $breakpoint-xl) {
      font-size: 28px;
      line-height: 36px;
    }
  }

  &__dividerWrapper {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    margin-bottom: 48px;

    @media (min-width: $breakpoint-md) {
      margin-bottom: 64px;
    }

    @media (min-width: $breakpoint-xl) {
      margin-bottom: 96px;
    }
  }

  &__wrap {
    @media (min-width: $breakpoint-md) {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0 32px;
    }
  }

  &__benefits {
    margin-top: 48px;

    @media (min-width: $breakpoint-md) {
      grid-column: 2;
    }

    @media (min-width: $breakpoint-xl) {
      margin-top: 64px;
    }
  }

  &__preview {
    margin-top: 32px;

    @media (min-width: $breakpoint-md) {
      align-items: center;
      display: flex;
      grid-row: 1/3;
      margin-top: 0;
    }

    @media (min-width: $breakpoint-xl) {
      grid-row: 1/4;
    }
  }

  &__stores {
    @media (min-width: $breakpoint-md) {
      grid-column: 1/-1;
      margin-top: 64px;
    }

    @media (min-width: $breakpoint-xl) {
      grid-column: 2;
    }
  }

  &__btnWrapper {
    display: flex;
    justify-content: center;
    margin-top: 48px;

    @media (min-width: $breakpoint-xl) {
      margin-top: 80px;
    }
  }

  &__btn {
    width: 100%;

    @media (min-width: $breakpoint-md) {
      max-width: 268px;
    }
  }
}

.wallet {
  display: grid;
  gap: 32px;
  justify-content: center;

  @media (min-width: $breakpoint-md) {
    align-items: center;
    grid-template-columns: auto 1fr;
    justify-content: flex-start;
  }

  &__logo {
    height: 96px;
    margin: 0 auto;
    width: 96px;
  }

  &__title {
    font-family: $font-secondary;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
  }
}

.benefitsList {
  &__item {
    align-items: flex-start;
    display: grid;
    gap: 24px;
    grid-template-columns: 48px 1fr;

    & + & {
      margin-top: 6px;
    }
  }

  &__title {
    color: rgba(0, 0, 0, 0.87);
    font-family: $font-secondary;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    padding: 12px 0;
  }

  &__text {
    @include text-body-1;

    color: rgba(0, 0, 0, 0.54);
    font-family: $font-family;
  }
}

.appPreview {
  text-align: center;
}

.stores {
  &__title {
    color: rgba(0, 0, 0, 0.87);
    font-family: $font-secondary;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 32px;
    text-align: center;

    @media (min-width: $breakpoint-xl) {
      text-align: left;
    }
  }

  &__wrap {
    display: grid;
    gap: 16px;
    justify-content: center;

    @media (min-width: $breakpoint-md) {
      grid-template-columns: auto auto;
    }

    @media (min-width: $breakpoint-xl) {
      justify-content: flex-start;
    }
  }
}
</style>
